import styled from 'styled-components';

export const Container = styled.div`
  min-height: 24px;
  margin: 8px 0 24px 0;
`;
